import { cookieKeys, getCookie } from "@helpers/cookies";
import axios from "axios";
import { AxiosRequestConfig } from "axios";

interface AxiosRequestConfigWithRetry extends AxiosRequestConfig {
  _retry?: boolean;
}

function handleUrl() {
  if (
    window.location.href.includes("localhost") ||
    window.location.href.includes(":3000")
  )
    return "https://bedev.direcional.com.br/bora-vender/v1";

  if (window.location.href.includes("dev"))
    return "https://bedev.direcional.com.br/bora-vender/v1";

  if (window.location.href.includes("qa"))
    return "https://beqa.direcional.com.br/bora-vender/v1";

  if (window.location.href.includes("stage"))
    return "https://bestage.direcional.com.br/bora-vender/v1";

  return "https://be.direcional.com.br/bora-vender/v1";
}

const api = axios.create({
  baseURL: handleUrl(),
  headers: {
    client_id: "b53793b2-7c67-42f4-ac30-06f3a6295179",
  },
});

// Interceptor para adicionar token nas requisições
api.interceptors.request.use((config) => {
  const token = getCookie(cookieKeys.token);

  config.headers["Authorization"] = `Bearer ${token}`;

  return config;
});

// Interceptor para tratar respostas e refresh token
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config as
      | AxiosRequestConfigWithRetry
      | undefined;

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/login") &&
      !originalRequest.url?.includes("/refresh-token")
    ) {
      originalRequest._retry = true;

      window.dispatchEvent(new CustomEvent("sessionExpired"));
    }

    return Promise.reject(error);
  },
);

export default api;
